module.exports = __webpack_public_path__ + "14e579614301d637b688dc6fa3b88034.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/state_farm_2023_chart.png
// module id = 1734
// module chunks = 0